import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import ProspectMain from "../components/propects/ProspectMain";
import { setListId } from "../store/slices/ownerSlice";

type Props = { utils: any; setShowExpiredAlert: any };

const ProspectImport = (props: Props) => {
  const dispatch = useDispatch();
  const { listId } = useParams();

  useEffect(() => {
    if (!listId) return;
    dispatch(setListId(listId));
  }, [dispatch, listId]);

  return (
    <div className="flex h-full min-h-0 w-full bg-background-grey">
      <ProspectMain
        utils={props.utils}
        setShowExpiredAlert={props.setShowExpiredAlert}
        view="import"
      />
    </div>
  );
};

export default ProspectImport;
